import { tw } from '@/utils/tw';

const Columns = tw.theme({
  base: `group/columns columns relative flex flex-col empty:hidden`,
});

export default Columns;
